import { render, staticRenderFns } from "./ItemSection.vue?vue&type=template&id=1ed2b561&scoped=true&"
import script from "./ItemSection.vue?vue&type=script&lang=ts&"
export * from "./ItemSection.vue?vue&type=script&lang=ts&"
import style0 from "./ItemSection.vue?vue&type=style&index=0&id=1ed2b561&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed2b561",
  null
  
)

export default component.exports